import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getDistributions } from 'store/actions';

const initialState = {
    newsroomTree: [],
    newsrooms: {},
    activeNewsroom: null,
    order: [],
    error: null,
    loading: false
};

/*
const getDistributionTreeStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const getDistributionTreeFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}
*/
// function wrap child distributions into children of newsroom
const getNewsroomChildren = (level) => {
    // init children object
    let children = [];
    // init length counter
    let length = 0;
    // check if level has children
    if (level.children.length > 0) {
        // process children
        level.children.forEach((item, index) => {
            // init item
            let _item = item.project;
            // update object with metadata
            updateObject(_item, item.project.data.metadata.fields);
            // set created (for sorting)
            _item['created'] = item.project.metadata.fields.created;
            _item['isChild'] = true;
            // append newsroom
            children[length] = _item;
            children[length]['name'] = item.project.name;
            children[length]['children'] = getNewsroomChildren(item);
            // increment length
            length ++;
        });
    }

    // return child tree
    return children;
};

const getNewsroomTreeSuccess = (state, action) => {
    
    // init newsroom tree
    let newsroomTree= [];
    // init length counter
    let length = 0;
    // process first level
    action.children.forEach((item, index) => {
        // init item
        let _item = item.project;
        // update object with metadata
        updateObject(_item, item.project.data.metadata.fields);
        // set created (for sorting)
        _item['created'] = item.project.metadata.fields.created;
        _item['isChild'] = false;
        // append newsroom
        newsroomTree[length] = _item;
        newsroomTree[length]['name'] = item.project.name;
        newsroomTree[length]['children'] = getNewsroomChildren(item);
        // increment length
        length ++;
    });

    // init flat list of newsrooms
    let newsrooms = {};
    // function to flatten distribution tree
    const flattenTree = function(children) {
        // loop through children
        children.forEach((item, index) => {
            // init item
            let _item = {};
            // set data
            _item = item.data;
            // set meta
            updateObject(_item, item.data.metadata.fields);
            // set created
            _item['created'] = item.created;
            // store in flat list
            newsrooms[item.data.id] = _item;
            // check for childs
            if(item.children.length > 0) {
                // append children
                flattenTree(item.children);
            }
        });
    };
    // execute flatten function
    flattenTree(newsroomTree);

    return updateObject(state, {
        newsroomTree: newsroomTree,
        newsrooms: newsrooms,
        loading: false
    });
}

const setActiveNewsroom = (state, action) => {
	if(!action.id) {
		return updateObject( state, { activeNewsroom: null });
	}
	
	const newsroom = state.newsrooms[action.id];
	return updateObject( state, { activeNewsroom: newsroom });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_NEWSROOM_TREE_START: 
			return updateObject( state, { error: null, loading: true } );
        case actionTypes.GET_NEWSROOM_TREE_SUCCESS: 
			return getNewsroomTreeSuccess(state, action);
        case actionTypes.GET_NEWSROOM_TREE_FAIL: 
			return updateObject( state, { error: action.error, loading: false });
		case actionTypes.NEWSROOM_SET_ACTIVE: 
			return setActiveNewsroom(state, action);
        default: 
            return state;
    }
}

export default reducer;
